export default "__VITE_ASSET__Dvfhc70m__"